export enum LinkExternalAccountFormFields {
  ACCOUNT_NUMBER = 'accountNumber',
  ACCOUNT_OWNER = 'accountOwnerName',
  ACCOUNT_TYPE = 'accountType',
  INSTITUTION_NAME = 'institutionName',
  ROUTING_NUMBER = 'routingNumber',
}
